/* Irio — page-fx.js
 * Scroll reveal (opacity+rise / image unmask) for [data-reveal] / [data-reveal-img].
 * Idempotent, respects prefers-reduced-motion, re-runs on shopify:section:load.
 */
(function () {
  "use strict";
  if (window.__irioFx) return;
  window.__irioFx = true;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function run() {
    var els = document.querySelectorAll("[data-reveal]:not(.is-in), [data-reveal-img]:not(.is-in)");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -80px 0px" });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  document.addEventListener("shopify:section:load", run);
})();
